import {Breakpoints, Image} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React from 'react'
import {useSelector} from 'react-redux'
import {bannerTitle, bannerWrapper} from '../../../assets/css-vars/bannerUtils'
import TrackingAction from '../../../tracking-manager'
import {Banners} from '../../../types/singleModelInterface'
import {useFeatureServices} from '../../../use-feature-services'
import stripTags from '../../../utils/text/stripTags'
import {
    getVehiclePromotionsButtonClickData,
    TRACKING,
} from '../../../utils/tracking/getTrackingData'
import setTracking, {
    checkTrackingManager,
} from '../../../utils/tracking/tracking-utils/setTracking'
import {RootState} from '../../rootReducer'
import BannerSubTitle from './BannerSubTitle'

const BigBannerLink = styled.a`
    ${bannerWrapper};
    display: block;
    text-decoration: none;
    color: ${(props) => props.theme.colors.content.primary};

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        position: sticky;
        top: 10px;
    }
`

const BigBannerImageWrapper = styled.div`
    overflow: hidden;
    border-radius: 16px;
`

const BigBannerMainTitle = styled.h2`
    font-size: ${(props) => props.theme.size.static350};
    line-height: 1.2;
    ${bannerTitle}

    p {
        margin: 0;
    }
`

const BigBannerTextWrapper = styled.div`
    margin-top: 30px;
`

export interface BigBanner extends Banners {
    modelName: string
    modelSlug: string
}

export default function BigBanner(props: BigBanner): React.JSX.Element {
    const {tracking: trackingManager} = useFeatureServices()
    const trackingBrand = useSelector(
        (state: RootState) => state.general.trackingBrand
    )
    const isShowroom = useSelector(
        (state: RootState) => state.general.isShowroom
    )

    return (
        <div>
            <BigBannerLink
                href={props.cta_url}
                onClick={() => {
                    if (checkTrackingManager(trackingManager)) {
                        const clickData = getVehiclePromotionsButtonClickData(
                            TRACKING.LINK_NAME_BIG_BANNER_CLICK,
                            props.modelName,
                            props.modelSlug,
                            trackingBrand,
                            isShowroom,
                            stripTags(props.title)
                        )

                        setTracking(
                            trackingManager,
                            TrackingAction.VWBasic_VehiclePromotionsButton_Click,
                            clickData
                        )
                    }
                }}
            >
                <BigBannerImageWrapper>
                    <Image src={props.image} alt="" />
                </BigBannerImageWrapper>

                <BigBannerTextWrapper>
                    {props.label ? (
                        <BannerSubTitle label={props.label} />
                    ) : undefined}

                    {props.title.length ? (
                        <BigBannerMainTitle
                            dangerouslySetInnerHTML={{
                                __html: props.title,
                            }}
                        />
                    ) : undefined}
                </BigBannerTextWrapper>
            </BigBannerLink>
        </div>
    )
}
